const summaryStyle = () => ({
	header: {
		margin: '24px auto 16px',
		width: 400,
	},
	data: {
		maxWidth: 400,
		margin: '0 auto',
	},
});

export default summaryStyle;
